module.exports = __webpack_public_path__ + "static/media/certificate.94d39ed0.svg";